import _ from 'lodash';
import Element from './Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';
import * as members from '../privates/privateMembers';
import {validate} from '../privates/validations/validation';
import platformUtils from '../privates/platformUtils';

/**
 * @class Video
 * @summary An element that displays a video.
 * @classdesc
 *  **Deprecation Note:** This video player has been deprecated. Use the
 *  [VideoPlayer]($w.VideoPlayer.html) element instead.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @queryable
 * @viewername wysiwyg.viewer.components.Video
 * @definitionId wysiwyg.viewer.components.Video
 * @tagname Video
 */
class Video extends Element {

  /**
   * @member videoUrl
   * @memberof $w.Video
   * @param {external:String} newUrl
   */
    set videoUrl(newUrl) {
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'videoUrl',
            dataToValidate: {videoUrl: newUrl},
            compName: this.id
        })) {
            return;
        }
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const videoUrlUtils = platformUtils.getVideoUrlUtils();
        const newVideoData = videoUrlUtils.getVideoDataFromUrl(newUrl);
        if (!_.isEmpty(newVideoData)) {
            RMI.setData(compId, newVideoData);
        }
    }


    /**
     * @member videoUrl
     * @label property
     * @syntax
     * get videoUrl(): string
     * set videoUrl(value: string): void
     * @summary Sets or gets the URL of the video.
     * @description
     *  **Deprecation Note:** This video player has been deprecated. Use the
     *  [VideoPlayer]($w.VideoPlayer.html) element instead.
     *
     *  Setting the value of the `videoUrl` property sets the video that the
     *  element plays.
     *
     *  Getting the value of the `videoUrl` property gets the URL of the video
     *  that the element plays.
     * @snippet [Video-videoUrl_set.es6=Set the video to play]
     * @snippet [Video-videoUrl_get.es6=Get the video to play]
     * @type {external:String}
     * @memberof $w.Video
     * @instance
     */
    get videoUrl() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const compData = RMI.getData(compId);
        const videoUrlUtils = platformUtils.getVideoUrlUtils();
        return videoUrlUtils.getVideoUrl(compData);
    }
}

mixin(Video.prototype, HiddenCollapsedMixin.prototype);

export default Video;
